module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/index.js
// module id = 1395
// module chunks = 7